import { render, staticRenderFns } from "./advertise.vue?vue&type=template&id=6243adb8&scoped=true"
import script from "./advertise.vue?vue&type=script&lang=js"
export * from "./advertise.vue?vue&type=script&lang=js"
import style0 from "./advertise.vue?vue&type=style&index=0&id=6243adb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243adb8",
  null
  
)

export default component.exports